export const LOGIN_REQUEST = 'AUTH.LOGIN_REQUEST'
export const LOGIN_REQUEST_SUCCESS = 'AUTH.LOGIN_REQUEST_SUCCESS'
export const LOGIN_REQUEST_FAILURE = 'AUTH.LOGIN_REQUEST_FAILURE'

export const REGISTER_REQUEST = 'AUTH.REGISTER_REQUEST'
export const REGISTER_REQUEST_SUCCESS = 'AUTH.REGISTER_REQUEST_SUCCESS'
export const REGISTER_REQUEST_FAILURE = 'AUTH.REGISTER_REQUEST_FAILURE'

export const GET_CURRENT_USER_REQUEST = "AUTH.GET_CURRENT_USER_REQUEST";
export const GET_CURRENT_USER_SUCCESS = "AUTH.GET_CURRENT_USER_SUCCESS";
export const GET_CURRENT_USER_FAILURE = "AUTH.GET_CURRENT_USER_FAILURE";

export const LOGOUT = "AUTH.LOGOUT";